"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _actionTypes = require("./actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

var _commons = require("egov-ui-kit/utils/commons");

var _isEmpty = require("lodash/isEmpty");

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// console.log('hello reducer file',actionTypes);
// const mergeServiceWithActions = (payload) => {
//   return (
//     payload &&
//     payload.actionHistory &&
//     payload.actionHistory.reduce((result, item, index) => {
//       if (!isEmpty(item) && !isEmpty(item.actions) && payload.services[index]) {
//         result.push({
//           ...payload.services[index],
//           actions: item.actions,
//         });
//       }
//       return result;
//     }, [])
//   );
// };

var intialState = {
  loading: false,
  error: false,
  CheckConRefAmt: false,
  name: "Ram",
  errorMessage: "",
  byId: {},
  categoriesById: {},
  complaintDepartment: [],
  complaintSector: [],
  order: ""
};
console.log('intialState in reducer==>>', intialState);
var complaintsReducer = function complaintsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : intialState;
  var action = arguments[1];
  var type = action.type,
      overWrite = action.overWrite;

  switch (type) {

    case actionTypes.APPLICATION_FETCH_COMPLETE:
      console.log('action.payload in reducer', action.payload);
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        applicationData: action.payload
      });
    case actionTypes.BOOKING_DATA_COMPLETE:
      console.log('BOOKING_DATA_COMPLETE', action.payload);
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        applicationData: action.payload
      });
    case actionTypes.BOOKING_DATA_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.ROOMPAYMENTCOMPLETE:
      console.log('BOOKING_DATA_COMPLETE', action.payload);
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        RoomPaymentReceipt: action.payload
      });
    case actionTypes.ROOMPAYMENT_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.ROOMPERMISSIONLETTERCOMPLETE:
      console.log('BOOKING_DATA_COMPLETE', action.payload);
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        RoomPermissionLetter: action.payload
      });
    case actionTypes.ROOMPERMISSIONLETTER_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.EMPPACCPERMISSIONLETTERCOMPLETE:
      console.log('BOOKING_DATA_COMPLETE', action.payload);
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        EmpPaccPermissionLetter: action.payload
      });
    case actionTypes.EMPPACCPERMISSIONLETTER_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.ESAMPARKRECEIPTCOMPLETE:
      console.log('BOOKING_DATA_COMPLETE', action.payload);
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        PaymentReceiptByESamp: action.payload
      });
    case actionTypes.ESAMPARKRECEIPTCOMPLETE_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.CREATE_WATER_TANKER_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        createWaterTankerApplicationData: action.payload
      });
    case actionTypes.CREATE_PARKCCAPP_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        createPACCApplicationData: action.payload
      });
    case actionTypes.CREATE_PACCAPP_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.UPDATE_PARKCCAPP_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        updatePACCApplicationData: action.payload
      });

    case actionTypes.UPDATE_PACCAPP_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.CREATE_WATER_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.CREATE_PACCAPP_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.DOWNLOAD_BWT_APPLICATION_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadBWTApplicationDetails: action.payload
      });
    case actionTypes.DOWNLOAD_BWT_APPLICATION_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.DOWNLOAD_RECEIPT_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadPaymentReceiptDetails: action.payload
      });

    case actionTypes.DOWNLOAD_LETTER_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadPermissionLetterDetails: action.payload
      });
    case actionTypes.DOWNLOAD_LETTER_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.DOWNLOAD_APPLICATION_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadApplicationDetails: action.payload
      });
    case actionTypes.PAYMENT_FETCH_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        paymentData: action.payload

      });

    case actionTypes.HISTORY_FETCH_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        HistoryData: action.payload
      });
    case actionTypes.AFTER_PAYMENT_FETCH_DETAILS:
      console.log('action.payload,', action.payload);
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        fetchPaymentAfterPayment: action.payload
      });

    case actionTypes.MCCAPPLICATION_FETCH_COMPLETE:
      console.log("in mcc sucess");
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        MccApplicationData: action.payload
      });
    case actionTypes.MCCAPPLICATION_FETCH_ERROR:
      console.log("in mcc failure");
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.APPLICATION_FETCH_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.DOWNLOAD_RECEIPT_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.DOWNLOAD_APPLICATION_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.HISTORY_FETCH_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.AFTER_PAYMENT_FETCH_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.PAYMENT_FETCH_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.COMPLAINTS_CATEGORIES_FETCH_SUCCESS:
      var categoriesById = (0, _commons.transformById)(action.payload.MdmsRes["RAINMAKER-PGR"].ServiceDefs, "serviceCode");
      return (0, _extends3.default)({}, state, {
        loading: false,
        categoriesById: (0, _extends3.default)({}, state.categoriesById, categoriesById)
      });
    case actionTypes.COMPLAINTS_DEPARTMENT_FETCH_SUCCESS:
      var complaintDepartment = (0, _commons.transformById)(action.payload.MdmsRes["RAINMAKER-PGR"].PgrDepartment, "code");
      return (0, _extends3.default)({}, state, {
        loading: false,
        complaintDepartment: (0, _extends3.default)({}, state.complaintDepartment, complaintDepartment)
      });

    case actionTypes.APPLICATION_SECTOR_FETCH_SUCCESS:
      var applicationSector = (0, _commons.transformById)(action.payload.MdmsRes["Booking"].Sector, "code");
      var applicationPmode = (0, _commons.transformById)(action.payload.MdmsRes["Booking"].Payment_Mode, "code");
      var sImageUrl = action.payload.MdmsRes["Booking"].Booking_Config;
      console.log('payload in sImageUrl', sImageUrl);
      //  let a = action.payload.MdmsRes["Booking"];

      // console.log('applicationSector,Payment_Mode',applicationPmode,'aaaaa',a)
      return (0, _extends3.default)({}, state, {
        loading: false,
        applicationSector: (0, _extends3.default)({}, state.applicationSector, applicationSector),
        applicationPmode: (0, _extends3.default)({}, state.applicationPmode, applicationPmode),
        sImageUrl: (0, _extends3.default)({}, state.sImageUrl, sImageUrl)
      });

    case actionTypes.APPLICATION_TYPE_FETCH_SUCCESS:
      var applicationType = action.payload.MdmsRes["Booking"];
      console.log('applicationType', applicationType);
      return (0, _extends3.default)({}, state, {
        loading: false,
        applicationType: (0, _extends3.default)({}, state.applicationType, applicationType)
      });

    case actionTypes.COMPLAINTS_SECTOR_FETCH_SUCCESS:
      var complaintSector = (0, _commons.transformById)(action.payload.MdmsRes["RAINMAKER-PGR"].Sector, "code");
      console.log('complaintSector', complaintSector);
      return (0, _extends3.default)({}, state, {
        loading: false,
        complaintSector: (0, _extends3.default)({}, state.complaintSector, complaintSector)
      });
    case actionTypes.COMPLAINTS_SORT_ORDER:
      return (0, _extends3.default)({}, state, {
        loading: false,
        order: action.order
      });
    case actionTypes.REF_AMOUNT_CONDITION:
      console.log("actionAmount--", action);
      return (0, _extends3.default)({}, state, {
        loading: false,
        CheckConRefAmt: true,
        name: "Shayam"
      });
    case actionTypes.COMPLAINTS_SEND_MESSAGE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        ShareMetaData: action.message
      });
    case actionTypes.COMPLAINTS_SEND_MESSAGE_SHAREMEDIA:
      return (0, _extends3.default)({}, state, {
        loading: false,
        ShareMetaData: (0, _extends3.default)({}, state.ShareMetaData, {
          shareMedia: action.message
        })
      });
    case actionTypes.PAYMENT_PER_DAY_FETCH_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        perDayRate: action.payload
      });
    case actionTypes.PAYMENT_PER_DAY_FETCH_FETCH_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.OSBMPAYMENT_PER_DAY_FETCH_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        OSBMperDayRate: action.payload
      });
    case actionTypes.OSBMPAYMENT_PER_DAY_FETCH_FETCH_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.DOWNLOAD_NEWRECEIPT_COMPLETE_CG:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadReceiptDetailsforCG: action.payload
      });
    case actionTypes.DOWNLOAD_NEWRECEIPT_ERROR_CG:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.DOWNLOAD_PLMCC_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadMccPermissionLetter: action.payload
      });
    case actionTypes.DOWNLOAD_PLMCC_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.DOWNLOAD_RECEIPT_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadPaymentReceiptDetails: action.payload
      });
    case actionTypes.DOWNLOAD_RECEIPT_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.DOWNLOAD_MCCAPP_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadMccAppp: action.payload
      });
    case actionTypes.DOWNLOAD_MCCAPP_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.DOWNLOAD_RECEIPT_COMPLETE_CG:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadPaymentReceiptDetailsforCG: action.payload
      });
    case actionTypes.DOWNLOAD_RECEIPT_ERROR_CG:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.DOWNLOAD_APPLICATION_COMPLETE_CG:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadApplicationDetailsforCG: action.payload
      });
    case actionTypes.DOWNLOAD_APPLICATION_ERROR_CG:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.DOWNLOAD_APPLICATION_COMPLETE_PCC:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadApplicationDetailsforPCC: action.payload
      });
    case actionTypes.DOWNLOAD_APPLICATION_ERROR_PCC:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.DOWNLOAD_PERMISSIONLETTER_COMPLETE_PCC:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadPermissionLetterDetailsforPCC: action.payload
      });
    case actionTypes.DOWNLOAD_PERMISSIONLETTER_ERROR_PCC:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.DOWNLOAD_RECEIPT_COMPLETE_PCC:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadReceiptDetailsforPCC: action.payload
      });
    case actionTypes.DOWNLOAD_RECEIPT_ERROR_PCC:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.COMPLAINTS_SEND_MESSAGE_SHARECONTENT_TO:
      var shareCont = state.ShareMetaData.shareContent;
      shareCont.map(function (elem) {
        elem.to = action.message;
      });
      return (0, _extends3.default)({}, state, {
        loading: false,
        ShareMetaData: (0, _extends3.default)({}, state.ShareMetaData, {
          shareContent: shareCont
        })
      });
    case actionTypes.DOWNLOAD_ESAMPARK_APP_COMPLETE_PCC:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        Downloadesamparkdetails: action.payload
      });
    case actionTypes.DOWNLOAD_ESAMPARK_APP__ERROR_PCC:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.DOWNLOAD_ESAMPARK_PL_COMPLETE_PCC:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        Downloadesamparkdetailspl: action.payload
      });
    case actionTypes.DOWNLOAD_ESAMPARK_APP__ERROR_PCC:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.FACILATION_CHARGES_FETCH_SUCCESS:
      // let facilationChargesSuccess = transformById(action.payload.MdmsRes["BillingService"].TaxHeadMaster, "code");          
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        facilationChargesSuccess: action.payload
      });
    // return {
    //   ...state,
    //   loading: false,
    //   facilationChargesSuccess: {
    //     ...state.facilationChargesSuccess,
    //     ...facilationChargesSuccess,
    //   }
    // }
    case actionTypes.DOWNLOAD_ESAMPARK_APP__ERROR_PCC:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    //REFUNDINIT_COMPLETE
    case actionTypes.REFUNDINIT_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        dataforRefund: action.payload
      });

    case actionTypes.DOWNLOAD_WATERTANER_RECEIPT_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        waterTankerPaymentReceipt: action.payload
      });

    case actionTypes.PACC_CITIZEN_RECEIPT_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadCitizenPACCReceipt: action.payload
      });
    case actionTypes.PACC_CITIZEN_RECEIPT_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.PACC_CITIZEN_PERMISSION_LETTER_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        DownloadCitizenPACCPermissionLetter: action.payload
      });
    case actionTypes.PACC_CITIZEN_RECEIPT_PERMISSION_LETTER_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.CITIZEN_COMM_PL_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        CitizenCCPermissionLetter: action.payload
      });
    case actionTypes.CITIZEN_COMM_PL_COMPLETE_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.DOWNLOAD_CG_REFUND_RECEIPT_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        cgRefundReceiptData: action.payload
      });
    case actionTypes.DOWNLOAD_CG_REFUND_RECEIPT_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.DOWNLOAD_CG_REFUND_APPLICATION_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        cgRefundApplicationData: action.payload
      });
    case actionTypes.DOWNLOAD_CG_REFUND_APPLICATION_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });
    case actionTypes.DOWNLOAD_CANCEL_RECEIPT_COMPLETE:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        cancelReceiptData: action.payload
      });
    case actionTypes.DOWNLOAD_CANCEL_RECEIPT_ERROR:
      return (0, _extends3.default)({}, state, {
        loading: false,
        fetchSuccess: true,
        error: true,
        errorMessage: action.error
      });

    case actionTypes.FACILATION_FETCH_SUCCESS:
      var applicationFetchfaciliation = (0, _commons.transformById)(action.payload.MdmsRes["BillingService"].TaxHeadMaster, "code");
      console.log("applicationFetchfaciliation--", applicationFetchfaciliation);
      var TaxHeadMaster = action.payload.MdmsRes.BillingService.TaxHeadMaster;
      console.log("TaxHeadMaster--", TaxHeadMaster);
      var facilation;
      var arrayName = [];
      arrayName.push(action.payload.MdmsRes.BillingService.TaxHeadMaster);
      console.log("arrayName--", arrayName);
      //  for(let i = 0; i < arrayName.length; i++){
      //    if(arrayName[i].code==="FACILITATION_CHARGE")
      //      {
      //         facilation = facilitationCharge
      //       }
      //   }
      //   console.log("facilation--Inreducer",facilation)

      return (0, _extends3.default)({}, state, {
        loading: false,
        arrayName: (0, _extends3.default)({}, state.arrayName, arrayName)
      });

    default:
      return state;
  }
};

exports.default = complaintsReducer;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/bookings/reducer.js
// module id = 3013
// module chunks = 1143